var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEqualitypromotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5.55228 4 6 4.44772 6 5V21C6 21.5523 5.55228 22 5 22C4.44772 22 4 21.5523 4 21V5C4 4.44772 4.44772 4 5 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4C19.5523 4 20 4.44772 20 5V14C20 14.5523 19.5523 15 19 15C18.4477 15 18 14.5523 18 14V5C18 4.44772 18.4477 4 19 4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 4.5708C7.45299 4.5708 6.44772 4.98132 5.7 5.71423C5.30559 6.10083 4.67246 6.0945 4.28586 5.70009C3.89926 5.30568 3.90559 4.67254 4.3 4.28594C5.42157 3.18658 6.92948 2.5708 8.5 2.5708C10.0705 2.5708 11.5784 3.18658 12.7 4.28594C13.4477 5.01885 14.453 5.42937 15.5 5.42937C16.547 5.42937 17.5523 5.01885 18.3 4.28594C18.6944 3.89934 19.3275 3.90568 19.7141 4.30009C20.1007 4.6945 20.0944 5.32763 19.7 5.71423C18.5784 6.81359 17.0705 7.42937 15.5 7.42937C13.9295 7.42937 12.4216 6.81359 11.3 5.71423C10.5523 4.98132 9.54701 4.5708 8.5 4.5708Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 13.5708C7.45299 13.5708 6.44772 13.9813 5.7 14.7142C5.30559 15.1008 4.67246 15.0945 4.28586 14.7001C3.89926 14.3057 3.90559 13.6725 4.3 13.2859C5.42157 12.1866 6.92948 11.5708 8.5 11.5708C10.0705 11.5708 11.5784 12.1866 12.7 13.2859C13.4477 14.0189 14.453 14.4294 15.5 14.4294C16.547 14.4294 17.5523 14.0189 18.3 13.2859C18.6944 12.8993 19.3275 12.9057 19.7141 13.3001C20.1007 13.6945 20.0944 14.3276 19.7 14.7142C18.5784 15.8136 17.0705 16.4294 15.5 16.4294C13.9295 16.4294 12.4216 15.8136 11.3 14.7142C10.5523 13.9813 9.54701 13.5708 8.5 13.5708Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualitypromotion);
export default __webpack_public_path__ + "static/media/equality.promotion.eb1bcb66b1bbe3e03776a17a827a6e36.svg";
export { ForwardRef as ReactComponent };